export default __webpack_public_path__ + "static/media/loading.a2abd418.gif";